module.exports = __webpack_public_path__ + "img/ke.8af29f16.svg";